// initial state
const state = { user: {} }

const getters = {
  loggedIn: state => !!state.user["cognito:username"],
  username: state => state.user["cognito:username"]
}

const mutations = {
  SIGN_OUT: state => {
    state.user = {}
  },
  SET_USER: (state, payload) => (state.user = payload)
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
